import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import api from '../../axios/axiosConfig';
import { useAuth } from '../../context/AuthContext';
import { useBrandContext } from '../../context/BrandContext';
import { useHeaderContext } from '../../context/HeaderContext';
import { useToast } from '../../context/ToastModalContext';

import Button from '../../components/button/Button';
import Input from '../../components/input/Input';

import { unRegisterPushNotification } from '../../services/userService';

import './AccountDeletion.css';

const AccountDeletion = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const authContext = useAuth();
  const brandContext = useBrandContext();
  const { setHeaderConfig } = useHeaderContext();

  const STRING_DELETE_TYPE = 'EXCLUIR';

  const handleSignOut = () => {
    const pushToken = authContext.storedDevicePushToken || authContext.expoPushToken;
    // Usar o tipo específico do device token ou fallback para expo
    let notificationProvider = 'expo';
    if (authContext.storedDevicePushToken) {
      notificationProvider = authContext.storedDevicePushTokenType || 'expo';
    }

    unRegisterPushNotification(
      pushToken,
      authContext.platform,
      authContext.appVersion,
      notificationProvider,
      brandContext.appId
    );
    authContext.setToken(null);
    navigate(`/${brandContext.brandName}/`);
  };

  type Inputs = {
    field: string;
  };

  const [form, setForm] = useState<Inputs>({
    field: '',
  });

  const handleSubmit = async () => {
    try {
      const response = await api.delete(`/UserDelete/${authContext.user.id}`);
      if (response.status === 200) {
        handleSignOut();
      }
    } catch (error) {
      showToast({
        children: () => (
          <div className='toast-stop-charging-modal-container'>
            <p className='toast-stop-charging-modal-text'>
              Erro ao tentar excluir sua conta. Tente novamente mais tarde.
            </p>
          </div>
        ),
        allowButtonClosed: true,
        closeButtonText: 'OK',
      });
      throw error;
    }
  };

  useEffect(() => {
    return () => {};
  }, []);

  useEffect(() => {
    setHeaderConfig({
      headerText: 'Excluir Conta',
      showLogo: false,
      showActionButtons: true,
    });
    return () => setHeaderConfig({});
  }, [brandContext.brandName, navigate, setHeaderConfig]);

  return (
    <main>
      <div>
        <h4>Você tem certeza de que deseja excluir sua conta?</h4>
        <span>
          Ao fazer isso, seus dados serão apagados dos nossos sistemas. Se
          houver créditos restantes, eles não poderão ser recuperados.
        </span>
      </div>

      <form
        onSubmit={(event) => {
          event.preventDefault();
          handleSubmit();
        }}
      >
        <div>
          <h4>Digite {STRING_DELETE_TYPE} para confirmar</h4>
          <Input
            htmlFor='field'
            type='text'
            id='field'
            value={form.field}
            onChange={(event) => {
              setForm({ ...form, field: event.target.value });
            }}
          />
        </div>

        <div>
          <Button
            children='Quero excluir'
            spinnerSecondary={true}
            type='submit'
            disabled={form.field !== STRING_DELETE_TYPE}
            style={{
              backgroundColor:
                form.field === STRING_DELETE_TYPE ? 'red' : 'grey',
              color: 'white',
              border: 'none',
              marginBottom: '28px',
              cursor:
                form.field === STRING_DELETE_TYPE ? 'pointer' : 'not-allowed',
            }}
          />

          <Button
            type='button'
            children='Cancelar'
            spinnerSecondary={true}
            onClick={() => navigate(-1)}
            style={{
              backgroundColor: '#fff',
              color: '#787E7D',
              border: '1px solid #787E7D',
              marginBottom: '28px',
            }}
          />
        </div>
      </form>
    </main>
  );
};

export default AccountDeletion;
